var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlaB573(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.216,
    height: 80.358,
    viewBox: "0 0 75.216 80.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34353",
    "data-name": "Group 34353",
    transform: "translate(-131.525 -694.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32431",
    "data-name": "Group 32431",
    transform: "translate(134 697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87832",
    "data-name": "Rectangle 87832",
    width: 35.079,
    height: 64.293,
    rx: 9.186,
    transform: "translate(0 24.805) rotate(-45)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26406",
    "data-name": "Path 26406",
    d: "M5283.619,2219.426a4.087,4.087,0,1,1-4.087-4.088",
    transform: "translate(-5254.962 -2205.149)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26407",
    "data-name": "Path 26407",
    d: "M5311.977,2247.785a4.087,4.087,0,1,1-4.087-4.087",
    transform: "translate(-5272.89 -2223.078)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26408",
    "data-name": "Path 26408",
    d: "M5340.336,2276.143a4.088,4.088,0,1,1-4.088-4.087",
    transform: "translate(-5290.818 -2241.007)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26409",
    "data-name": "Path 26409",
    d: "M5368.694,2304.5a4.087,4.087,0,1,1-4.087-4.088",
    transform: "translate(-5308.748 -2258.935)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26410",
    "data-name": "Path 26410",
    d: "M5255.037,2248.007a4.088,4.088,0,1,1-4.087-4.088",
    transform: "translate(-5236.891 -2223.219)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26411",
    "data-name": "Path 26411",
    d: "M5283.4,2276.366a4.088,4.088,0,1,1-4.088-4.088",
    transform: "translate(-5254.82 -2241.147)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26412",
    "data-name": "Path 26412",
    d: "M5311.754,2304.723a4.087,4.087,0,1,1-4.087-4.088",
    transform: "translate(-5272.749 -2259.076)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26413",
    "data-name": "Path 26413",
    d: "M5340.112,2333.083a4.088,4.088,0,1,1-4.088-4.087",
    transform: "translate(-5290.677 -2277.005)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26414",
    "data-name": "Path 26414",
    d: "M5226.731,2290.718l35.13,35.13a10.554,10.554,0,0,0,14.925,0l16.446-16.446",
    transform: "translate(-5224.165 -2252.805)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlaB573);
export default __webpack_public_path__ + "static/media/hla-b-57-3.f48847d28f7f3dd9e54e7093bde8bc75.svg";
export { ForwardRef as ReactComponent };